import React, { useState } from "react";
import { SidebarMenuItem } from "./SidebarMenuItem";
import { PageEnum } from "src/helpers/Enums";
import { SidebarMenuItemWithSub } from "./SidebarMenuItemWithSub";

const SidebarMenuMain = () => {
  const [openAccordions, setOpenAccordions] = useState({
    lists: false,
    creatives: false,
  });

  const handleAccordion = (accordionKey) => {
    setOpenAccordions((prev) => ({
      ...prev,
      [accordionKey]: !prev[accordionKey],
    }));
  };

  return (
    <div className={"w-full"}>
      <SidebarMenuItem to="/dashboard" title={PageEnum.DASHBOARD} />
      <SidebarMenuItem title={"Manage"} disabled={true} />
      <SidebarMenuItem to="/allCalendar" title={PageEnum.ALLCALENDAR} />
      <SidebarMenuItemWithSub
        to="/lists"
        title={PageEnum.LISTS}
        hasArrow={true}
        handleAccordion={() => handleAccordion("lists")}
        openAccordion={openAccordions.lists}
      >
        <SidebarMenuItem
          img={"/media/icons/arrowRight.svg"}
          to="/lists/SMS"
          title="Sms List"
          hasBullet={true}
        />
        <SidebarMenuItem
          to="/lists/SMSAnalytics"
          title={PageEnum.SMS_ANALYTICS}
          hasBullet={true}
        />
        <SidebarMenuItem
          img={"/media/icons/arrowRight.svg"}
          to="/lists/Email"
          title="Email List"
          hasBullet={true}
        />
        <SidebarMenuItem
          img={"/media/icons/arrowRight.svg"}
          to="/lists/TagManagement"
          title="Tag Management"
          hasBullet={true}
        />
      </SidebarMenuItemWithSub>
      <SidebarMenuItemWithSub
        to="/creatives"
        title={PageEnum.CREATIVES}
        hasArrow={true}
        handleAccordion={() => handleAccordion("creatives")}
        openAccordion={openAccordions.creatives}
      >
        <SidebarMenuItem
          img={"/media/icons/arrowRight.svg"}
          to="/creatives/sms"
          title="SMS Creative"
          hasBullet={true}
        />
        <SidebarMenuItem
          img={"/media/icons/arrowRight.svg"}
          to="/creatives/email"
          title="Email Creative"
          hasBullet={true}
        />
      </SidebarMenuItemWithSub>
      <SidebarMenuItem to="/offers" title={PageEnum.OFFERS} />
      <SidebarMenuItem to="/strategies" title={PageEnum.STRATEGIES} />
      <SidebarMenuItem title={"More"} disabled={true} />
      <SidebarMenuItem to="/settings" title={PageEnum.SETTINGS} />
    </div>
  );
};

export { SidebarMenuMain };
